(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["everteen-filters-sheet"] && !Shopify.designMode) return;
  try {
    (function () {
    function initEvtFilterSheet(root) {
      if (!root || root.dataset.evtInit === '1') return;
      root.dataset.evtInit = '1';

      const sheets = Array.from(root.querySelectorAll('[data-evt-sheet]'));
      const backdrop = root.querySelector('[data-evt-backdrop]');
      const snapshots = new WeakMap();
      let activeSheet = null;

      function snapshot(sheet) {
        const state = [];
        sheet.querySelectorAll('input[type="checkbox"], input[type="radio"], input[type="number"]').forEach((input) => {
          if (input.type === 'number') {
            state.push({ input, value: input.value });
          } else {
            state.push({ input, checked: input.checked });
          }
        });
        snapshots.set(sheet, state);
      }

      function restore(sheet) {
        const state = snapshots.get(sheet);
        if (!state) return;
        state.forEach((entry) => {
          if (entry.input.type === 'number') {
            entry.input.value = entry.value;
          } else {
            entry.input.checked = entry.checked;
          }
        });
      }

      function openSheet(sheet) {
        if (!sheet) return;
        if (activeSheet && activeSheet !== sheet) {
          closeSheet(activeSheet, { restoreState: false });
        }
        snapshot(sheet);
        sheet.classList.add('is-open');
        sheet.setAttribute('aria-hidden', 'false');
        if (backdrop) {
          backdrop.classList.add('is-open');
        }
        document.documentElement.classList.add('evt-fs-lock-scroll');
        activeSheet = sheet;
      }

      function closeSheet(sheet, options) {
        if (!sheet) return;
        const shouldRestore = !options || options.restoreState !== false;
        if (shouldRestore) {
          restore(sheet);
        }
        sheet.classList.remove('is-open');
        sheet.setAttribute('aria-hidden', 'true');
        if (backdrop) {
          backdrop.classList.remove('is-open');
        }
        document.documentElement.classList.remove('evt-fs-lock-scroll');
        if (activeSheet === sheet) {
          activeSheet = null;
        }
      }

      root.querySelectorAll('[data-evt-open]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const key = btn.getAttribute('data-evt-open');
          const sheet = root.querySelector('[data-evt-sheet="' + key + '"]');
          openSheet(sheet);
        });
      });

      root.querySelectorAll('[data-evt-close]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const sheet = btn.closest('[data-evt-sheet]');
          closeSheet(sheet);
        });
      });

      root.querySelectorAll('[data-evt-cancel]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const key = btn.getAttribute('data-evt-cancel');
          const sheet = root.querySelector('[data-evt-sheet="' + key + '"]');
          closeSheet(sheet);
        });
      });

      if (backdrop) {
        backdrop.addEventListener('click', () => {
          if (activeSheet) {
            closeSheet(activeSheet);
          }
        });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && activeSheet) {
          closeSheet(activeSheet);
        }
      });

      root.querySelectorAll('[data-evt-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = tab.getAttribute('data-evt-tab');
          const tabsList = tab.closest('[role="tablist"]');
          const panelsWrap = tabsList ? tabsList.parentElement.querySelector('.evt-fs__panels') : null;
          if (!tabsList || !panelsWrap) return;

          tabsList.querySelectorAll('[data-evt-tab]').forEach((t) => {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });

          panelsWrap.querySelectorAll('[data-evt-panel]').forEach((panel) => {
            const isActive = panel.getAttribute('data-evt-panel') === index;
            panel.classList.toggle('is-active', isActive);
            if (isActive) {
              panel.removeAttribute('hidden');
            } else {
              panel.setAttribute('hidden', '');
            }
          });
        });
      });
    }

    function boot(scope) {
      const root = (scope || document).querySelector ? (scope.matches && scope.matches('[data-evt-fs]') ? scope : (scope.querySelector ? scope.querySelector('[data-evt-fs]') : null)) : null;
      if (root) initEvtFilterSheet(root);
    }

    document.addEventListener('DOMContentLoaded', () => boot(document));
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
